<template>
  <div class="hello">
    <modal
      height="auto"
      classes="msg-modal"
      width="300px"
      :adaptive="true"
      name="message"
    >
      <div v-html="msg"></div>
    </modal>
    <header class="navbar">
      <img class="logo" src="../assets/logo1.png" alt="" />

      <span class="lang-switch">
        <a
          v-if="this.$i18n.locale === 'zh'"
          @click="changeLang('en')"
          href="javascript:;"
          >EN</a
        >
        <a v-else @click="changeLang('zh')" href="javascript:;">中</a>
      </span>
    </header>
    <div class="cover-container form-insc text-center w-100 m-auto align-left">
      <h1>{{ $t("nostrAssets") }}</h1>

      <div class="alert alert-danger" v-if="isTPwithoutNostr" role="alert">
        <p v-if="upgradeAndOpenSwitch" v-html="$t('upgradeAndOpenSwitch')"></p>
        <p v-else v-html="$t('upgradeAndOpenSwitchPC')"></p>
      </div>

      <p class="mb-1 mt-3 no-wrap">
        {{ $t("currentAddress") }}
      </p>

      <p>
        <input
          type="text"
          class="form-control"
          v-model="currentAddress"
          readonly
        />
      </p>

      <p class="mb-1 mt-3">{{ $t("tokenSymbol") }}:</p>
      <select class="form-control" v-model="selectedAsset">
        <option
          v-for="asset in assets"
          v-bind:key="asset.value"
          v-bind:value="asset.value"
        >
          {{ asset.text }}
        </option>
      </select>

      <p class="mb-1 mt-3">{{ $t("sendingAmount") }}:</p>

      <!-- <p>
        <input
          type="text"
          class="form-control"
          v-model="inputText"
          :placeholder="textPlaceholder"
        />
      </p> -->

      <p>
        <input
          type="text"
          class="form-control"
          v-model="sendingAmount"
          :placeholder="$t('amountPlaceHolder')"
        />
      </p>

      <p class="mb-1 mt-3">{{ $t("receiveAddresses") }}:</p>

      <textarea
        :placeholder="$t('addressPlaceHolder')"
        class="form-control"
        name=""
        id=""
        cols="30"
        rows="6"
        v-model="receiveAddressesText"
      ></textarea>
      <!-- <input type="number" class="form-control" v-model="times" /> -->

      <p class="mb-1 mt-3 confirm-btn-wrap" style="text-align: center">
        <button class="btn btn-primary" disabled v-if="sending">
          {{ $t("sending") }}
        </button>

        <button
          v-else-if="!currentAddress"
          class="btn btn-primary"
          @click="connectWallet()"
        >
          {{ $t("connect") }}
        </button>

        <button
          v-else-if="
            currentAddress && selectedAsset && hasEnoughBalance && sendingAmount
          "
          class="btn btn-primary"
          @click="send()"
        >
          {{ $t("send") }}
        </button>

        <button v-else class="btn btn-primary" disabled>
          {{ $t("send") }}
        </button>
      </p>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import Axios from "axios";
import { nip19, relayInit, getEventHash } from "nostr-tools";

const WS_SERVER = "wss://relay.nostrassets.com";

function sleep(second) {
  second = second || 1;
  return new Promise((res, rej) => {
    setTimeout(() => {
      res();
    }, second * 1000);
  });
}

export default {
  name: "HelloWorld",
  data() {
    return {
      msg: "",
      relay: null,
      currentAddress: "",
      currentPubkey: "",
      sending: false,
      inputText: "",
      selectedAsset: "",
      tokenList: [],
      receiveAddressesText: "",
      sendingAmount: "",
      balances: null,
      connected: false,
      isTPwithoutNostr: false,
      isMobileTP: false,
    };
  },
  created() {
    // this.queryTokenList();
  },
  mounted() {
    this.isMobileTP = navigator.userAgent.indexOf("TokenPocket") > -1;

    this.connectServer();

    setTimeout(() => {
      this.isTPwithoutNostr = window.tokenpocket && !window.nostr;
    }, 1000);
  },
  computed: {
    hasEnoughBalance() {
      if (
        this.selectedAsset &&
        this.balances &&
        this.receiveAddressesText &&
        this.sendingAmount
      ) {
        let content = _.trim(this.receiveAddressesText);

        if (!content) {
          return false;
        }

        let addresses = content.split(/[\n]/g);

        let mybalance = this.balances[this.selectedAsset].balance;
        console.log("mybalance", mybalance);

        console.log("need", this.sendingAmount * addresses.length);

        if (mybalance - this.sendingAmount * addresses.length > 0) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    assets() {
      if (this.balances) {
        return Object.keys(this.balances).map((item) => {
          return {
            text: item + ": " + this.balances[item].balanceShow,
            value: item,
          };
        });
      }
      return [];
    },
  },
  methods: {
    queryTokenList() {
      Axios.post(
        "https://market-api.nostrassets.com/assets/api/getTokenList"
      ).then((res) => {
        if (res.status === 200 && res.data && res.data.code === 0) {
          this.tokenList = res.data.data;
        }
        console.log(res);
      });
    },
    async connectServer() {
      this.relay = relayInit(WS_SERVER);
      this.relay.on("connect", () => {
        this.connected = true;
        console.log(`connected to ${this.relay.url}`);
      });
      this.relay.on("error", () => {
        console.log(`failed to connect to ${this.relay.url}`);
      });

      await this.relay.connect();

      // let sub = this.relay.sub([
      //   {
      //     ids: [
      //       "d7dd5eb3ab747e16f8d0212d53032ea2a7cadef53837e5a6c66d42849fcb9027",
      //     ],
      //   },
      // ]);
      // sub.on("event", (event) => {
      //   console.log("we got the event we wanted:", event);
      // });
      // sub.on("eose", () => {
      //   sub.unsub();
      // });
    },

    async connectWallet() {
      if (window.nostr) {
        let pubkey = await window.nostr.getPublicKey();

        this.currentPubkey = pubkey;

        this.currentAddress = nip19.npubEncode(pubkey);

        this.queryBalance();
      } else if (window.tokenpocket) {
        if (this.isMobileTP) {
          this.showMsg(this.$t("upgradeAndOpenSwitch"));
        } else {
          this.showMsg(this.$t("upgradeAndOpenSwitchPC"));
        }
      } else {
        this.showMsg(this.$t("downloadTP"));
      }
    },
    queryBalance() {
      Axios.post("https://market-api.nostrassets.com/assets/api/balanceOf", {
        user: this.currentAddress,
      }).then((res) => {
        if (
          res.status === 200 &&
          res.data.code === 0 &&
          Object.keys(res.data.data).length
        ) {
          this.balances = res.data.data;

          console.log(this.balances);

          setTimeout(() => {
            this.selectedAsset = Object.keys(this.balances)[0];
          }, 500);
        }
      });
    },
    showMsg(msg) {
      this.msg = msg;
      this.$modal.show("message");
    },
    changeLang(lang) {
      this.$i18n.locale = lang;
      localStorage.setItem("locale", lang);
      if (lang === "en") {
        Settings.defaultLocale = "en-US";
      } else {
        Settings.defaultLocale = "zh-CN";
      }
    },
    async sendOnce(addr, amount, symbol) {
      return new Promise(async (resolve, reject) => {
        try {
          let msg = `transfer ${amount} ${symbol} to ${addr}`;

          let content = await nostr.nip04.encrypt(
            "693d3f45b81c1f3557383fb955f3a8cb2c194c44ffba1e2f4566e678773b44f8",
            msg
          );
          console.log(content);

          let event = {
            content: content,
            kind: 4,
            tags: [
              [
                "p",
                "693d3f45b81c1f3557383fb955f3a8cb2c194c44ffba1e2f4566e678773b44f8",
              ],
            ],
            created_at: parseInt(new Date().getTime() / 1000),
            pubkey: this.currentPubkey,
          };

          event.id = getEventHash(event);

          let signedEvent = await nostr.signEvent(event);

          await this.relay.publish(signedEvent);

          resolve();
        } catch (err) {
          reject(err);
        }
      });
    },
    async send() {
      let content = _.trim(this.receiveAddressesText);

      if (!content) {
        return false;
      }

      let addresses = content.split(/[\n]/g);

      let isAllValid = true;

      addresses.forEach((item) => {
        try {
          nip19.decode(item);
        } catch (err) {
          isAllValid = false;
        }
      });

      if (!isAllValid) {
        this.showMsg(this.$t("addressInvalid"));
        return;
      }

      if (
        this.currentAddress &&
        this.selectedAsset &&
        this.hasEnoughBalance &&
        this.sendingAmount &&
        this.connected &&
        isAllValid &&
        addresses.length
      ) {
        let symbol = this.selectedAsset.toLowerCase();
        this.sending = true;

        let amount = this.sendingAmount;

        try {
          for (var i = 0; i < addresses.length; i++) {
            await this.sendOnce(addresses[i], amount, symbol);
            await sleep(2);
          }

          this.sending = false;
          this.showMsg(this.$t("sent"));

          setTimeout(() => {
            this.queryBalance();
          }, 3000);

          setTimeout(() => {
            this.queryBalance();
          }, 10000);
        } catch (err) {
          this.showMsg("Error");
          this.sending = false;
          console.log(err);
        }
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
h1 {
  margin-top: 24px;
  text-align: center;
  font-size: 26px !important;
}
.form-insc {
  max-width: 680px;
  width: 90% !important;
  font-size: 15px;
}
.align-left {
  text-align: left !important;
}

.radio-label {
  margin-right: 12px;
  input {
    margin-right: 4px;
  }
}

.logo {
  width: 60%;
  max-width: 240px;
}

.no-wrap {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

::placeholder {
  color: #ddd !important;
  opacity: 1; /* Firefox */
}

.tips {
  color: #666;
  font-size: 13px;
}

.lang-switch {
  float: right;
}

.msg-modal {
  padding: 24px 18px;
  border-radius: 8px;
  background: #eee;
}

.confirm-btn-wrap {
  .btn {
    padding-left: 64px;
    padding-right: 64px;
  }
}

.alert-danger {
  p {
    margin: 0;
  }
}

.navbar {
  padding: 20px;
}
</style>
